import {
  GET_PRONTO_PROVIDER_STATUS_REQUEST,
  GET_PRONTO_PROVIDER_STATUS_SUCCESS,
  GET_PRONTO_PROVIDER_STATUS_FAILURE,
  CREATE_PRONTO_PROVIDER_REQUEST,
  CREATE_PRONTO_PROVIDER_SUCCESS,
  CREATE_PRONTO_PROVIDER_FAILURE,
  GET_USER_INFO_REQUEST,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO_FAILURE
} from "./constants";

import { call, take, put } from "redux-saga/effects";
import { get, post } from "../../utils/api";
import settings from "../../utils/settings";
import { isEmpty } from 'lodash';

export function* getProntoProviderStatusFlow() {
  while (true) {
    yield take(GET_PRONTO_PROVIDER_STATUS_REQUEST);
    try {
      let response = yield call(get, {
        url: settings.getApiUrl(`service/pronto_integration_ms/api/pronto/status`),
      });
      const result = response.result;
      if (response.success) {
        yield put({
          type: GET_PRONTO_PROVIDER_STATUS_SUCCESS,
          providerStatusDetails: result,
          prontoId: result.provider_id,
          messageType: response.status == null ? "error" : "success",
          message: result.message,
          showError: false,
          refreshLoading: false,
          loadingFailed: false
        });
      }
      else {
        console.log("Error in get Pronto Status:", result.message);
        yield put({ type: GET_PRONTO_PROVIDER_STATUS_FAILURE, messageType: "error", message: "Unable to fetch details at the moment. Please retry in some time", showError: false, refreshLoading: false, loadingFailed: true });
      }
    } catch (error) {
      console.log("Pronto Get Status error: ", error);
      yield put({ type: GET_PRONTO_PROVIDER_STATUS_FAILURE, messageType: "error", message: error.message, showError: true, refreshLoading: false, loadingFailed: false });
    }
  }
}

export function* createProntoProviderFlow() {
  while (true) {

    yield take(CREATE_PRONTO_PROVIDER_REQUEST);
    try {
      let response = yield call(post, {
        url: settings.getApiUrl("service/pronto_integration_ms/api/pronto/signup"),
      });
      if (response.success) {

        const result = response.result;
        yield put({
          type: CREATE_PRONTO_PROVIDER_SUCCESS,
          providerStatusDetails: result,
          prontoId: result.provider_id,
          messageType: "success",
          message: "Provider created successfully!!",
          showError: true,
          refreshLoading: false,
          // loadingFailed: false 
        });

      } else {

        yield put({
          type: CREATE_PRONTO_PROVIDER_FAILURE,
          showError: true,
        });

      }

    } catch (error) {
      console.log("Error: createProntoProvider:", error);
      yield put({ type: CREATE_PRONTO_PROVIDER_FAILURE, showError: true, message: "Unable to process your request. Please try after some time!!!", messageType: "error" });
    }
  }
}

export function* getInstallerInfoFlow() {
  while (true) {
    yield take(GET_USER_INFO_REQUEST);
    try {
      let response = yield call(get, {
        url: settings.getApiUrl(`service/pronto_integration_ms/api/pronto/installer_info`),
      });
      const result = response.result;
      if (response.success) {
        if (!isEmpty(result.data)) {
          yield put({
            type: GET_USER_INFO_SUCCESS,
            isUsInstallerAdmin: result.data?.user?.us_installer_admin,
            installer_id: result.data?.company?.id,
            installer_name: result.data?.company?.name
          });
        }
      }
      else {
        yield put({
          type: GET_PRONTO_PROVIDER_STATUS_FAILURE,
          messageType: "error",
          message: "Unable to fetch installer details at the moment. Please retry in some time",
          // showError : false , refreshLoading : false, loadingFailed: true
        });
      }
    } catch (error) {
      yield put({
        type: GET_USER_INFO_FAILURE, messageType: "error",
        // message: error.message, showError : true , refreshLoading : false, loadingFailed: false
      });
    }
  }
}
